
export class Stats {
    yesCount = 0;
    noCount = 0;
    unreviewedCount = 0;
}
